function openSizeGuide() {
  const drawer = document.getElementById('size-guide-drawer');
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeSizeGuide() {
  const drawer = document.getElementById('size-guide-drawer');
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

function setUnit(unit, btn) {
  document.querySelectorAll('.size-guide-toggle__btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.size-guide-table td[data-cm]').forEach(cell => {
    cell.textContent = cell.dataset[unit];
  });
}

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeSizeGuide();
});
